import * as z from "zod/v4";

export const overrideNotReceivedGroups = {
  name: "overrideNotReceivedGroups" as const,
  input: z.object({ fulfillmentGroupIds: z.array(z.string()) }),
  output: z.void(),
};
